export enum WatchedDocumentStates {
  Idle,
  Queued,
  Loading,
  Error,
  Watching,
}
